<template>
  <el-row>
    <el-card shadow="none"
             class="form-card mb-15">
      <el-form :inline="true"
               :model="searchForm"
               ref="search_form"
               class="search-form">
        <el-form-item label="员工卡号:"
                      prop="no">
          <el-input v-model.trim="searchForm.no"
                    placeholder="员工卡号"></el-input>
        </el-form-item>
        <el-form-item label="员工姓名:"
                      prop="name">
          <el-input v-model.trim="searchForm.name"
                    placeholder="员工姓名"></el-input>
        </el-form-item>
        <el-form-item label="ID/IC卡号:"
                      prop="card_no">
          <el-input v-model.trim="searchForm.card_no"
                    placeholder="ID/IC卡号">
            <el-button slot="append"
                       @click="readIC()"
                       style="font-size:30px"
                       icon="el-icon-postcard"></el-button>
          </el-input>
          <span v-if="countDown">请读卡{{timer}}</span>
        </el-form-item>
        <el-form-item label="所属区域:"
                      prop="area_id">
          <el-select v-model="searchForm.area_id"
                     placeholder="请选择所属区域"
                     @change="areaSelChange()">
            <el-option v-for="item in areaList"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设备权限:"
                      prop="lock_id">
          <el-select v-model="searchForm.lock_id"
                     placeholder="请选择设备">
            <el-option v-for="item in lockList"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="员工状态:"
                      prop="status">
          <el-select v-model="searchForm.status"
                     placeholder="状态">
            <el-option label="全部"
                       value=""></el-option>
            <el-option label="正常"
                       value="1"></el-option>
            <el-option label="锁定"
                       value="2"></el-option>
            <el-option label="注销"
                       value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     @click="searchSubmit('search_form')">查询
          </el-button>
          <el-button icon="el-icon-refresh"
                     @click="resetForm('search_form')">重置
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-row>
      <el-button v-has="'/person/add'"
                 type="primary"
                 @click="handleAdd">新增</el-button>
      <el-button v-has="'/person/del'"
                 type="primary"
                 @click="multipleDelete">批量删除人员</el-button>
      <el-button v-has="'/person_lock/batch_add'"
                 type="primary"
                 @click="multipleAuth">批量增加权限</el-button>
      <el-button v-has="'/person_lock/batch_add'"
                 type="primary"
                 @click="multipleDelAuth">批量删除权限</el-button>
      <el-upload class="c-import-btn"
                 :show-file-list="false"
                 :headers="{ token: authId }"
                 ref="upload"
                 :action="url"
                 accept=".xlsx,.xls"
                 :on-success="handleUploadSuccess">
        <el-button v-has="'/person/import'"
                   slot="trigger"
                   type="primary">导入</el-button>
      </el-upload>
      <el-button v-has="'/person/export'"
                 type="primary"
                 @click="handleExport">导 出</el-button>
    </el-row>
    <el-card shadow="none"
             class="mt-15">
      <el-table max-height="575"
                ref="multipleTable"
                :data="tableData"
                @selection-change="handleSelectionChange">
        <el-table-column type="selection"
                         width="50"> </el-table-column>
        <el-table-column v-for="(item, index) in tableTitle"
                         :fixed="item.fixed"
                         :key="index"
                         :label="item.name"
                         :prop="item.prop"
                         :min-width="item.width"
                         :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <template v-if="item.prop === 'status'">
              <el-tag v-if="scope.row[item.prop] === '1'"
                      type="success">正常</el-tag>
              <el-tag v-else-if="scope.row[item.prop] === '2'"
                      type="danger">锁定</el-tag>
              <el-tag v-else
                      type="info">注销</el-tag>
            </template>
            <template v-else-if="item.prop === 'medium'">
              <el-link class="mr-5"
                       :underline="false"
                       :type="scope.row[item.prop].indexOf(1) > -1 ? 'primary' : 'danger'"
                       @click="inputCpu(scope.row)">员工卡</el-link>
              <el-link class="mr-5"
                       :underline="false"
                       :type="scope.row[item.prop].indexOf(2) > -1 ? 'primary' : 'danger'"
                       @click="inputIc(scope.row)">IC卡</el-link>
              <el-link class="mr-5"
                       :underline="false"
                       :type="scope.row[item.prop].indexOf(3) > -1 ? 'primary' : 'danger'"
                       @click="inputIcId(scope.row)">身份证</el-link>
              <el-link class="mr-5"
                       :underline="false"
                       :type="scope.row[item.prop].indexOf(4) > -1 ? 'primary' : 'danger'"
                       @click="inputFinger(scope.row)">指纹</el-link>
            </template>
            <span v-else>{{ scope.row[item.prop] }}</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right"
                         label="操作"
                         width="210">
          <template slot-scope="scope">
            <el-button v-has="'/person/edit'"
                       size="mini"
                       type="primary"
                       @click="handleEdit(scope.row)">编辑</el-button>
            <el-button v-has="'/person_lock/edit'"
                       size="mini"
                       type="success"
                       @click="handleAuth(scope.row)">授权</el-button>
            <el-popover placement="bottom"
                        trigger="click">
              <el-button v-has="'/person/passwordReset'"
                         type="text"
                         size="mini"
                         @click="passWdReset(scope.row)">密码重置</el-button>
              <el-button v-has="'/person/del'"
                         size="mini"
                         type="text"
                         @click="handleDelete(scope.row)">删除</el-button>
              <el-button slot="reference"
                         plain
                         size="mini"
                         type="primary"
                         style="margin-left: 10px;">更多</el-button>
            </el-popover>
          </template>
        </el-table-column>
      </el-table>
      <Pagination :total="pagination.total"
                  :pageSize="pagination.perPage"
                  @handleSizeChange="handleSizeChange"
                  @handleCurrent="handleCurrentChange"></Pagination>
    </el-card>
    <add-human v-if="showHumanModal"
               :isShow="showHumanModal"
               :data="humanData"
               @handleClose="closeHumanModal"></add-human>
    <assign-auth v-if="showAuthModal"
                 :isShow="showAuthModal"
                 :data="authData"
                 @handleClose="closeAuthModal"></assign-auth>
    <input-info v-if="showInfoModal"
                :isShow="showInfoModal"
                :data="infoData"
                @handleClose="closeInfoModal"></input-info>
    <input-pass v-if="showPassModal"
                :isShow="showPassModal"
                :data="passData"
                @handleClose="closePassModal"></input-pass>
    <input-id v-if="showIdModal"
              :isShow="showIdModal"
              :data="idData"
              @handleClose="closeIdModal"></input-id>
  </el-row>
</template>

<script>
import fetch from '@/common/api'
import mediumApi from '@/common/medium'
import utils from '@/common/utils'
import AddHuman from '@/views/humanResources/human/AddHuman'
import AssignAuth from '@/views/humanResources/human/AssignAuth'
import InputInfo from '@/views/humanResources/human/InputInfo'
import InputPass from '@/views/humanResources/human/InputPass'
import InputId from '@/views/humanResources/human/InputId'
import Pagination from '@/components/pagination/Pagination'
// import XLSX from 'xlsx'
export default {
  components: { AddHuman, AssignAuth, InputInfo, InputPass, InputId, Pagination },
  data() {
    return {
      countDown: false,
      timer: 45,
      timeObj: null,
      randomNum: '',
      url: fetch.importPerson,
      authId: localStorage.getItem('token'),
      orgList: [],
      areaList: [],
      lockList: [],
      searchForm: {
        no: '',
        name: '',
        card_no: '',
        lock_id: '',
        department_id: '',
        area_id: '',
        status: ''
      },
      tableTitle: [
        {
          prop: 'no',
          name: '员工卡号',
          width: '120'
        },
        {
          prop: 'name',
          name: '姓名',
          width: '100'
        },
        {
          prop: 'sex',
          name: '性别',
          width: '60'
        },
        // {
        //   prop: 'dep_names',
        //   name: '机构',
        //   width: '240'
        // },
        {
          prop: 'medium',
          name: '开锁方式',
          width: '200'
        },
        {
          prop: 'status',
          name: '状态',
          width: '80'
        },
        {
          prop: 'contact_ctx',
          name: '联系方式',
          width: '120'
        },
        {
          prop: 'back_person',
          name: '应急联系人',
          width: '100'
        },
        {
          prop: 'back_contact_ctx',
          name: '应急联系方式',
          width: '120'
        },
        {
          prop: 'effe_date',
          name: '起始日期',
          width: '120'
        },
        {
          prop: 'exp_date',
          name: '腾退日期',
          width: '120'
        },
        {
          prop: 'lock_names',
          name: '设备名称',
          width: '200'
        },
        {
          prop: 'remark',
          name: '备注',
          width: '150'
        }
        // {
        //   prop: 'count_fprint',
        //   name: '指纹数量',
        //   width: '100'
        // },
        // {
        //   prop: 'count_fvein',
        //   name: '静脉数量',
        //   width: '100'
        // },
        // {
        //   prop: 'count_ic',
        //   name: 'IC卡数量',
        //   width: '100'
        // },
        // {
        //   prop: 'count_id',
        //   name: '身份证数量',
        //   width: '100'
        // },
      ],
      tableData: [],
      // 分页相关
      pagination: {
        total: 0,
        currentPage: 1,
        perPage: 10
      },
      // 选中数据
      multipleSelection: [],
      // 添加人员相关
      showHumanModal: false,
      humanData: {
        type: 'add'
      },
      // 人员授权相关
      showAuthModal: false,
      authData: {
        id: -1
      },
      // 录入信息相关
      showInfoModal: false,
      infoData: {},
      //录入身份证相关
      showIdModal: false,
      idData: {},
      // 录入密码相关
      showPassModal: false,
      passData: {},
      tmpArr: []
    }
  },
  created() {
    this.getList()
    this.getAreaTree()
  },
  methods: {
    //区域选择联动设备筛选
    areaSelChange() {
      this.lockList = []
      this.searchForm.lock_id = ''
      fetch
        .getLockList({ perPage: 0, currentPage: 0, type: 'old', area_id: this.searchForm.area_id })
        .then((data) => {
          data.procData(
            data.res,
            (data) => {
              this.lockList = data.list
            },
            (err) => {
              this.$message.error(err)
            }
          )
        })
    },
    //读取ic卡号
    readIC() {
      // loading倒计时提醒
      this.countDown = true
      this.timeObj = setInterval(() => {
        if (this.timer > 0) {
          this.timer--
        }
        if (this.timer === 0) {
          this.countDown = false
          clearInterval(this.timeObj)
        }
      }, 1000)
      this.randomNum = this.getRandomNum()
      mediumApi
        .getMediumInfo(
          {
            medType: 'ic',
            medTag: this.randomNum
          },
          { timeout: 45000 }
        )
        .then((data) => {
          data.procData(
            data.res,
            (data) => {
              if (data.medType === 'ic' && data.medTag === this.randomNum) {
                this.randomNum = ''
                this.searchForm.card_no = data.medValue
                this.$message.success('读取成功')
              }
              this.countDown = false
              clearInterval(this.timeObj)
            },
            (err) => {
              this.countDown = false
              clearInterval(this.timeObj)
              this.$message.error(err)
            }
          )
        })
    },
    getRandomNum() {
      let randomNum = new Date().getTime() + ''
      let tmpLen = randomNum.length
      let $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
      let maxPos = $chars.length
      for (var i = 0; i < 32 - tmpLen; i++) {
        randomNum += $chars.charAt(Math.floor(Math.random() * maxPos))
      }
      return randomNum
    },
    // 获取列表
    getList() {
      const { perPage, currentPage } = this.pagination
      fetch
        .getPersonList({
          perPage: perPage,
          currentPage: currentPage,
          ...this.searchForm
        })
        .then((data) => {
          data.procData(
            data.res,
            (data) => {
              this.pagination.total = Number(data.total)
              this.tableData = data.list.map((item) => {
                item.medium = [
                  Number(item.count_cpu) ? 1 : '',
                  Number(item.count_ic) ? 2 : '',
                  Number(item.count_id) ? 3 : '',
                  Number(item.count_fprint) ? 4 : '',
                  Number(item.count_fvein) ? 5 : '',
                  Number(item.count_passwd) ? 6 : ''
                ]
                item.sex = item.sex === '1' ? '男' : item.sex === '2' ? '女' : '未知'
                return item
              })
            },
            (err) => {
              this.$message.error(err)
            }
          )
        })
    },
    //  格式化名称
    titleFormat(data, prefix) {
      if (data.length === 0) {
        return []
      }
      data.forEach((item) => {
        let tmp = item
        tmp.name = prefix + item.name
        this.tmpArr.push(tmp)
        if (item.children && item.children.length > 0) {
          this.titleFormat(item.children, '• ' + prefix)
        }
      })
      return this.tmpArr
    },
    // 获取数据
    getAreaTree() {
      fetch.getAreaTree({}).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this.tmpArr = []
            this.areaList = this.titleFormat(data.treeData, '• ')
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    // 搜索提交
    searchSubmit() {
      this.pagination.perPage = 10
      this.pagination.currentPage = 1
      this.getList()
    },
    resetForm(formName) {
      this.pagination.perPage = 10
      this.pagination.currentPage = 1
      this.$refs[formName].resetFields()
      this.getList()
    },
    // 选择变化
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 分页
    handleSizeChange(val) {
      this.pagination.perPage = val
      this.pagination.currentPage = 1
      this.getList()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.getList()
    },
    // 导入
    handleUploadSuccess(res) {
      if (200 === Number(res.code)) {
        this.$message.success('导入成功')
      } else {
        this.$message.error(res.msg)
      }
    },
    // 导出
    handleExport() {
      fetch
        .exportPerson(
          {
            ...this.searchForm
          },
          { responseType: 'blob' }
        )
        .then((data) => {
          var blob = new Blob([data.res])
          let date = utils.format(new Date().getTime(), 'yyyy-MM-dd')
          let filename = '人员列表-' + date + '.xls'
          var aEle = document.createElement('a')
          let url = URL.createObjectURL(blob)
          aEle.href = url
          aEle.download = filename
          aEle.click()
          window.URL.revokeObjectURL(url)
        })
      // const sheetData1 = this.tableData.map((item, index) => ({
      //   序号: index,
      //   ID: item.id,
      //   设备名称: item.name
      // }))
      // const sheet1 = XLSX.utils.json_to_sheet(sheetData1)
      // const wb = XLSX.utils.book_new()
      // XLSX.utils.book_append_sheet(wb, sheet1, '收件人列表')
      // const workbookBlob = this.workbook2blob(wb)
      // this.openDownloadDialog(workbookBlob, '收件人列表.xls')
    },
    // 添加人员
    handleAdd() {
      this.showHumanModal = true
      this.humanData = {
        type: 'add'
      }
    },
    // 批量删除
    multipleDelete() {
      if (this.multipleSelection.length > 0) {
        this.$confirm('是否确定删除选中的数据?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            let selectIds = this.multipleSelection
              .map((item) => {
                return item.id
              })
              .join(',')
            this.delPerson(selectIds)
          })
          .catch(() => {})
      } else {
        this.$message.warning('请选择人员后重试')
      }
    },
    // 编辑
    handleEdit(data) {
      this.showHumanModal = true
      this.humanData = {
        type: 'edit',
        id: data.id
      }
    },
    // 关闭添加弹窗
    closeHumanModal(type) {
      if (type === 'refresh') {
        this.getList()
      }
      this.showHumanModal = false
    },
    // 批量授权
    multipleAuth() {
      if (this.multipleSelection.length > 0) {
        this.showAuthModal = true
        let selectIds = this.multipleSelection
          .map((item) => {
            return item.id
          })
          .join(',')
        this.authData = {
          type: 'multi',
          id: selectIds
        }
      } else {
        this.$message.warning('请选择人员后重试')
      }
    },
    // 批量删除授权
    multipleDelAuth() {
      if (this.multipleSelection.length > 0) {
        this.showAuthModal = true
        let selectIds = this.multipleSelection
          .map((item) => {
            return item.id
          })
          .join(',')
        this.authData = {
          type: 'del',
          id: selectIds
        }
      } else {
        this.$message.warning('请选择人员后重试')
      }
    },
    // 授权
    handleAuth(data) {
      this.showAuthModal = true
      this.authData = {
        type: 'single',
        id: data.id
      }
    },
    closeAuthModal(type) {
      if (type === 'refresh') {
        this.getList()
      }
      this.showAuthModal = false
    },
    // 密码重置
    passWdReset(data) {
      this.$confirm('是否确定重置【' + data.name + '】的登录密码?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          fetch.resetPersonPassword({ id: data.id }).then((data) => {
            data.procData(
              data.res,
              () => {
                this.getList()
                this.$message.success('操作成功')
              },
              (err) => {
                this.$message.error(err)
              }
            )
          })
        })
        .catch(() => {})
    },
    // 删除
    handleDelete(data) {
      this.$confirm('是否确定删除人员【' + data.name + '】?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.delPerson(data.id)
        })
        .catch(() => {})
    },
    // 录入员工卡
    inputCpu(data) {
      this.showInfoModal = true
      this.infoData = {
        from: 'cpu',
        id: data.id
      }
    },
    // 录入IC
    inputIc(data) {
      this.showInfoModal = true
      this.infoData = {
        from: 'ic',
        id: data.id
      }
    },
    // 录入身份证序列号
    inputIcId(data) {
      this.showInfoModal = true
      this.infoData = {
        from: 'id',
        id: data.id
      }
    },
    //录入指纹
    inputFinger(data) {
      this.showInfoModal = true
      this.infoData = {
        from: 'fprint',
        id: data.id
      }
    },
    // 录入静脉
    inputVein(data) {
      this.showInfoModal = true
      this.infoData = {
        from: 'fvein',
        id: data.id
      }
    },
    // 录入人脸id
    inputFace(data) {
      this.showInfoModal = true
      this.infoData = {
        from: 'id',
        id: data.id
      }
    },
    //录入身份证
    inputId(data) {
      this.showIdModal = true
      this.idData = {
        from: 'id',
        id: data.id
      }
    },
    // 录入密码
    inputPass(data) {
      this.showPassModal = true
      this.passData = {
        id: data.id
      }
    },
    closeInfoModal() {
      this.getList()
      this.showInfoModal = false
    },
    closeIdModal() {
      this.getList()
      this.showIdModal = false
    },
    closePassModal() {
      this.getList()
      this.showPassModal = false
    },

    // 删除方法
    delPerson(ids) {
      fetch.delPerson({ id: ids }).then((data) => {
        data.procData(
          data.res,
          () => {
            this.getList()
            this.$message.success('操作成功')
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    }
    // // 将workbook装化成blob对象
    // workbook2blob(workbook) {
    //   // 生成excel的配置项
    //   var wopts = {
    //     // 要生成的文件类型
    //     bookType: 'xlsx',
    //     // 是否生成Shared String Table，官方解释是，如果开启生成速度会下降，但在低版本IOS设备上有更好的兼容性
    //     bookSST: false,
    //     type: 'binary'
    //   }
    //   var wbout = XLSX.write(workbook, wopts)
    //   // 将字符串转ArrayBuffer
    //   function s2ab(s) {
    //     var buf = new ArrayBuffer(s.length)
    //     var view = new Uint8Array(buf)
    //     for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff
    //     return buf
    //   }
    //   var blob = new Blob([s2ab(wbout)], {
    //     type: 'application/octet-stream'
    //   })
    //   return blob
    // },
    // // 将blob对象创建bloburl，然后用a标签实现弹出下载框
    // openDownloadDialog(blob, fileName) {
    //   if (typeof blob == 'object' && blob instanceof Blob) {
    //     blob = URL.createObjectURL(blob) // 创建blob地址
    //   }
    //   var aLink = document.createElement('a')
    //   aLink.href = blob
    //   // HTML5新增的属性，指定保存文件名，可以不要后缀，注意，有时候 file:///模式下不会生效
    //   aLink.download = fileName || ''
    //   var event
    //   if (window.MouseEvent) event = new MouseEvent('click')
    //   //   移动端
    //   else {
    //     event = document.createEvent('MouseEvents')
    //     event.initMouseEvent(
    //       'click',
    //       true,
    //       false,
    //       window,
    //       0,
    //       0,
    //       0,
    //       0,
    //       0,
    //       false,
    //       false,
    //       false,
    //       false,
    //       0,
    //       null
    //     )
    //   }
    //   aLink.dispatchEvent(event)
    // }
  }
}
</script>

<style></style>
